var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isUnlocked)?_c('span',{style:(_vm.color)},[_vm._v(" "+_vm._s(_vm.name)+" "+_vm._s(_vm.gainText)+". "),_c('br')]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }